import script from "./SipServerInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SipServerInfo.vue?vue&type=script&setup=true&lang=js"

import "./SipServerInfo.vue?vue&type=style&index=0&id=95f28ec8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95f28ec8"]])

export default __exports__